export default __webpack_public_path__ + "static/media/goods10.47facb4c.gif";